import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {CatalogContainerModel} from '../../../../../models/aggregates/catalog/catalog-container.model';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Core2Config} from '../shared/core2Config';
import {ApiResponseModel, ApiVisa, Pagination, PagingResponseModel} from "../shared";
import {
  UserCatalogLightPrivateResponse,
  UserCatalogLinkResponse
} from "../../../../../models/aggregates/catalog/user-catalog-link-response.model";
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class CatalogLoginSubjectLinkService extends BaseApiTemplateService<UserCatalogLinkResponse> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'catalog-login-subject-links';
    this.httpClient = http;
  }

  catalogPublic(apiVisa: ApiVisa): Observable<ApiResponseModel<UserCatalogLinkResponse>>{
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/public';
    }
    return this.httpClient.get<ApiResponseModel<UserCatalogLinkResponse>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa)
    );
  }

  catalogPrivate(apiVisa: ApiVisa, offset?: number, limit?: number): Observable<ApiResponseModel<UserCatalogLinkResponse>> {
    const validatedOffset = offset == null ? 0 : offset;
    const validatedLimit = offset == null ? 2 : limit;

    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/private' + `?offset=${validatedOffset}&limit=${validatedLimit}`;
    }

    return this.httpClient.get<ApiResponseModel<UserCatalogLinkResponse>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa)
    );

  }

  catalogLightPrivate(apiVisa: ApiVisa): Observable<ApiResponseModel<UserCatalogLightPrivateResponse>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/private-light';
    }
    return this.httpClient.get<ApiResponseModel<UserCatalogLightPrivateResponse>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa)
    );
  }

  getByCriteriaTenantEp(
    tenantCode: string,
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<UserCatalogLinkResponse>> {
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'catalog-login-subject-links/' + tenantCode + '/login-tenant-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<UserCatalogLinkResponse>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  getByCriteriaByTenantCustomEp(
    tenantGuid: string,
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<UserCatalogLinkResponse>> {
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'catalog-login-subject-links/custom/' + tenantGuid + '/tenant-admin-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<UserCatalogLinkResponse>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

}
